import React, { useState } from 'react';
import axios from 'axios';
import { site_url } from "../config.js";

function TestEmail() {
  const [customerId, setCustomerId] = useState('60');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const handleSendTestEmail = async () => {
    if (!email) {
      setMessage({ type: 'error', text: 'Please enter an email address' });
      return;
    }

    setLoading(true);
    setMessage({ type: '', text: '' });

    try {
      const response = await axios.post(site_url + '/send_test_email', {
        customer_id: customerId,
        email: email
      });

      if (response.data.status === 'success') {
        setMessage({ type: 'success', text: response.data.message || 'Test email sent successfully!' });
      } else {
        setMessage({ type: 'error', text: response.data.message || 'Failed to send test email' });
      }
    } catch (error) {
      console.error('Error sending test email:', error);
      setMessage({ type: 'error', text: error.response?.data?.message || 'Error sending test email' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '20px', maxWidth: '400px', margin: '0 auto' }}>
      <h3>Test Email Sender</h3>
      <p style={{ fontSize: '14px', color: '#666' }}>
        Send a test email to verify email configuration
      </p>

      <div style={{ marginBottom: '15px' }}>
        <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>
          Customer ID
        </label>
        <input
          type="text"
          value={customerId}
          onChange={(e) => setCustomerId(e.target.value)}
          style={{
            width: '100%',
            padding: '10px',
            border: '1px solid #ddd',
            borderRadius: '5px'
          }}
        />
      </div>

      <div style={{ marginBottom: '15px' }}>
        <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>
          Email Address
        </label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter test email address"
          style={{
            width: '100%',
            padding: '10px',
            border: '1px solid #ddd',
            borderRadius: '5px'
          }}
        />
      </div>

      {message.text && (
        <div
          style={{
            padding: '10px',
            marginBottom: '15px',
            borderRadius: '5px',
            backgroundColor: message.type === 'success' ? '#d4edda' : '#f8d7da',
            color: message.type === 'success' ? '#155724' : '#721c24'
          }}
        >
          {message.text}
        </div>
      )}

      <button
        onClick={handleSendTestEmail}
        disabled={loading}
        style={{
          width: '100%',
          padding: '12px',
          backgroundColor: '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          cursor: loading ? 'not-allowed' : 'pointer',
          opacity: loading ? 0.7 : 1
        }}
      >
        {loading ? 'Sending...' : 'Send Test Email'}
      </button>
    </div>
  );
}

export default TestEmail;
